<template>
  <Message type="warning" class="campaign-url-setting-alert">
    <p class="campaign-url-setting-alert__text">
      開催中のリポスト・引用キャンペーンに、応募収集URLが設定されていないものがあります。<br />
      URLの設定時点から7日より前の応募は収集されないため、早めに対象のキャンペーン投稿のURLを設定してください。<br />
      設定方法の詳細は<a class="link" :href="helpHref" target="_blank" rel="noopener noreferrer" @click="onHelpClick"
        >こちら</a
      >をご覧ください。
    </p>

    <div class="campaign-url-setting-alert__campaigns">
      <div v-for="item in items" :key="item.id" class="campaign-url-setting-alert__campaign">
        <Account
          :name="item.account.name"
          :image="item.account.image"
          symbol="twitter"
          :is-display-name="false"
          tooltip
        />
        <a
          class="link ml-x1"
          role="button"
          tabindex="0"
          @click="onEditClick(item.id)"
          @keydown.enter="onEditClick(item.id)"
          @keydown.space.prevent="onEditClick(item.id)"
        >
          {{ item.campaignName }}
        </a>
      </div>
    </div>
  </Message>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Message from '@/client/components/_atoms/Message.vue'
import Account from '@/client/components/_molecules/Account.vue'

import { CampaignUrlSettingAlertItem } from './types'

export default defineComponent({
  name: 'CampaignUrlSettingAlert',
  components: {
    Message,
    Icon,
    Account
  },
  props: {
    items: {
      type: Array as PropType<CampaignUrlSettingAlertItem[]>,
      required: true
    },
    helpHref: {
      type: String,
      default: 'https://help-atelu.comnico.jp/set-campaign-post-url'
    }
  },
  setup(props, context) {
    function onHelpClick() {
      context.emit('help')
    }

    function onEditClick(id: number) {
      context.emit('edit', id)
    }

    return {
      onHelpClick,
      onEditClick
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-url-setting-alert {
  // Message(type="warning") の文字色（warning）を上書きし、全文を同一スタイルに統一する
  color: $text-color;

  &__text {
    margin: 0;
    font-size: $font-size;
    line-height: 22px;
  }

  &__campaigns {
    margin: $spacing-unit 0;
  }

  &__campaign {
    display: flex;
    align-items: center;

    & + & {
      margin-top: $spacing-unit;
    }
  }
}
</style>
